<template>
  <div class="box">
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">税务服务</div>
      <div class="t-t2box">
        <div class="t-t2">全程专人跟进 专业高效服务</div>
      </div>
    </div>

    <!-- 第一部分 -->
    <div class="row1">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">信息技术服务</div>
        <br />
        <div class="t2">用技术创造商业价值</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/products/shuishou/tubiao1.png" alt="" />
          </div>
          <div class="text1">移动APP开发</div>
          <div class="text2">以超低价</div>
          <div class="text3">享受团队专业服务</div>
          <div class="zixun" @click="goBto">立即咨询</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/shuishou/tubiao2.png" alt="" />
          </div>
          <div class="text1">工商年报</div>
          <div class="text2">正规软件</div>
          <div class="text3">高效处理 低差错率</div>
          <div class="zixun" @click="goBto">立即咨询</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/shuishou/tubiao3.png" alt="" />
          </div>
          <div class="text1">税务服务</div>
          <div class="text2">三层监管</div>
          <div class="text3">规范审批 避免税务风险</div>
          <div class="zixun" @click="goBto">立即咨询</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/shuishou/tubiao4.png" alt="" />
          </div>
          <div class="text1">税务咨询</div>
          <div class="text2">全方位服务</div>
          <div class="text3">合理筹划 降低财务成本</div>
          <div class="zixun" @click="goBto">立即咨询</div>
        </div>
      </div>
    </div>
    <!-- 第二部分 -->

    <!-- 第三部分 -->
    <div class="row2">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">我们优势</div>
        <!-- <div class="t2">打造企业管理终极利器</div> -->
      </div>
      <!-- 内容 -->
      <div class="box2">
        <div class="r2-tiem">
          <img src="@/image/products/shuishou/tu1.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">效益</div>
              <div class="line"></div>
              <div class="t2">营收目标实现，成本费用 受控，利润有保障</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/shuishou/tu2.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">管理</div>
              <div class="line"></div>
              <div class="t2">高效高质量的管理机制形成，重大 项目有突破，日常工作有效率</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/shuishou/tu3.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">执行力</div>
              <div class="line"></div>
              <div class="t2">有汇报，有指导，有监督，保障目标 达成和计划执行</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/shuishou/tu4.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">士气</div>
              <div class="line"></div>
              <div class="t2">奖优罚劣，主动复制，建立正向积 极文化，提升整体氛围</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 第三部分 -->
    <div class="row3">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">服务价值</div>
        <div class="t2">企业税务管理专家</div>
      </div>
      <!-- 内容 -->
      <div class="box2">
        <div class="r2-tiem">
          <img src="@/image/products/shuishou/tu5.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">提高效率 提升合规</div>
              <div class="t2">通过统一的数据口径、标准化的税务处理规则与 流程，实现税务业务自动化，提高税务基础工作 效率与准确性，提升合规遵从度。</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/shuishou/tu6.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">数据挖掘 赋能决策</div>
              <div class="t2">通过涉税数据挖掘、构建模型，为管理决策提供 支持，例如通过税务管理驾驶舱实时掌握成员单 位关键涉税信息，辅助高层管理决策。</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/shuishou/tu6.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">知识沉淀 经验传承</div>
              <div class="t2">通过涉税规则说明、涉税业务操作流程说明、税 务知识案例库、税务稽查管理等积累税务实务操 作知识与经验，通过系统沉淀并传承。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConstProduct',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/products/shangwu/banner.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}
//第一部分

.row1 {
  height: 650px;
  position: relative;
  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 58px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }
  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 650px;
    margin: 120px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;
    .item1 {
      width: 270px;
      height: 320px;
      // border: 1px solid;
      margin-right: 40px;
      box-shadow: 1px 1px 5px 3px #efefef;
      .img {
        width: 60px;
        height: 72px;
        margin: 45px auto 18px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text1 {
        width: 250px;
        text-align: center;
        margin: 15px auto 10px auto;
        font-size: 18px;
        letter-spacing: 2px;
      }
      .text2 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 2px auto;
        font-size: 15px;
        color: #999999;
      }
      .text3 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 10px auto;
        font-size: 15px;
        color: #999999;
      }

      .zixun {
        letter-spacing: 1px;
        width: 100px;
        height: 36px;
        color: #4581fb;
        line-height: 36px;
        text-align: center;
        border: 1px solid #4581fb;
        margin: 25px auto;
        border-radius: 4px;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;
      color: #4581fb;
      transition-timing-function: linear;
    }
    .item1:hover .zixun {
      background-color: #4581fb;
      color: #fff;
    }
  }
}
.row2 {
  height: 820px;
  overflow: hidden;

  background-color: #313131;
  position: relative;

  .title {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
      color: #fff;
    }
    .t2 {
      position: absolute;
      top: 120px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;
    width: 1200px;
    margin: 80px auto;
    border: 1px solid #fff;
    // justify-content: space-around;
    .r2-tiem {
      height: 480px;
      width: 300px;
      position: relative;
      border-radius: 6px;
      padding: 0;

      img {
        position: absolute;
        top: 0;

        width: 100%;
        height: 100%;
      }

      .yy {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        background-color: rgba($color: #000000, $alpha: 0.5);
        .tbox {
          position: absolute;
          top: 40%;
          color: #fff;
          overflow: hidden;
        }

        .t1 {
          font-size: 28px;
          height: 28px;
          width: 100%;
          text-align: center;
          margin-bottom: 25px;
          letter-spacing: 1px;
        }
        .line {
          height: 3px;
          width: 32px;
          background-color: #ffffff;
          margin: 0px auto 18px auto;
        }
        .t2 {
          width: 74%;
          font-size: 14px;
          margin: 0 auto;
          text-align: center;
          margin-bottom: 35px;
          font-weight: 300;
        }
      }

      .yy:hover {
        background-color: rgba($color: #000000, $alpha: 0.2);
      }
    }
  }
}

.row3 {
  height: 820px;
  overflow: hidden;

  background-color: #ffffff;
  position: relative;

  .title {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 120px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;

    width: 1300px;
    margin: 100px auto;
    justify-content: space-around;

    .r2-tiem {
      height: 473px;
      width: 378px;
      position: relative;

      border-radius: 6px;
      padding: 0;

      img {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
      }

      .yy {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        background-color: rgba($color: #000000, $alpha: 0.2);
        .tbox {
          position: absolute;
          bottom: 0;
          color: #fff;
          overflow: hidden;
        }

        .t1 {
          font-size: 28px;
          height: 28px;
          width: 100%;
          margin-bottom: 30px;
          letter-spacing: 1px;
          padding-left: 30px;
        }
        .line {
          height: 3px;
          width: 32px;
          background-color: #ffffff;
          margin: 0px auto 18px auto;
        }
        .t2 {
          margin-left: 30px;
          width: 84%;
          font-size: 14px;
          margin-bottom: 60px;
          font-weight: 300;
        }
      }
    }

    .r2-tiem:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;

      transition-timing-function: linear;
    }
  }
}
</style>
